import store from '@state/store'
import { diffTimeMinutes, formatQueryParams, possivelJSON } from '@utils/Format'
import con from '@services/connection'
import { bi, profissionais } from '@constants/URL'
import { MINUTES_TIMEOUT_REQUESTS } from '@constants/Numbers'

class APIBIProfissionais {
  async carregar(forceUpdate = false) {
    if (!forceUpdate) {
      if (
        !diffTimeMinutes(
          store.getters['bi/profissionaisDataAtualizacao'],
          MINUTES_TIMEOUT_REQUESTS
        )
      ) {
        console.log('Já carregou os profissionais recentemente')
        return store.getters['bi/profissionais']
      }
    }

    if (store.getters['bi/loadingProfissionais']) {
      console.log('Está carregando')
      return store.getters['bi/profissionais']
    }

    store.dispatch('bi/loadingProfissionais', true)

    const queryParams = formatQueryParams({
      with_data: true,
    })

    const r = await con.get(bi.profissionais + queryParams)

    if (r && r.status === 200) {
      if (typeof r.value === 'string') {
        r.value = possivelJSON(r.value)
      }
      await store.dispatch('bi/setProfissionais', r)
    }

    store.dispatch('bi/loadingProfissionais', false)

    return store.getters['bi/profissionais']
  }

  async salvarProfissional({
    id,
    id_pj,
    id_profissional,
    codigo_assessor,
    id_plano_carreira,
    id_nivel_carreira,
    id_segmentacao,
    id_senoridade,
    segmentacao_2,
    auc,
    auc_potencial,
    roa_medio,
    salario,
    comissionamento,
    id_segmentacao_proposta,
    id_senoridade_proposta,
    id_nivel_carreira_proposto,
    equipe,
    id_equipe,
    id_filial,
    tags,
    participacao_societaria,
    data_inicio_aai,
    data_entrada_escritorio,
    quantidade_clientes,
    data_referencia,
    nome_profissional = '',
    email = '',
    nome,
  }) {
    const profissional = {
      id_pj,
      id_profissional,
      codigo_assessor,
      id_plano_carreira,
      // id_nivel_carreira,
      // id_segmentacao,
      id_senoridade,
      // segmentacao_2,
      // auc,
      // auc_potencial,
      // roa_medio,
      salario,
      // comissionamento:
      //   comissionamento <= 1 ? comissionamento : comissionamento / 100,
      // id_segmentacao_proposta,
      // id_senoridade_proposta,
      // id_nivel_carreira_proposto,
      id_equipe,
      id_filial,
      tags,
      participacao_societaria: participacao_societaria
        ? participacao_societaria / 100
        : null,
      data_inicio_aai,
      data_entrada_escritorio,
      // quantidade_clientes,
      // data_referencia,
      nome_profissional,
      email,
      nome,
    }

    store.dispatch('bi/loadingProfissionais', true)

    const data = {
      data: JSON.stringify(profissional),
    }

    let r
    if (id > 0) {
      r = await con.put(bi.profissionais + `/${id}`, data)
    } else {
      r = await con.post(bi.profissionais, data)
    }

    store.dispatch('bi/loadingProfissionais', false)

    if (r && r.status === 200) {
      store.dispatch('bi/addProfissionais', r.value[0] || r.value)
      this.carregar(true)
    }

    return r || {}
  }

  async alterarEmLote({ professionals = [], attrs = [] }) {
    if (!professionals.length) {
      return {
        status: 200,
        message: 'Nenhum profissional informado',
        value: null,
      }
    }
    store.dispatch('bi/loadingProfissionais', true)

    const data = {
      data: JSON.stringify(
        professionals.map((item) => {
          const aux = {}
          aux.id_profissional = item.id_profissional
          attrs.forEach((key) => {
            aux[key] = item[key]
          })
          return aux
        })
      ),
    }

    const r = await con.post(bi.profissionaisLote, data)

    store.dispatch('bi/loadingProfissionais', false)

    if (r && r.status === 200) {
      this.carregar(true)
    }

    return r || {}
  }

  async alterarPlanoCarreira({ dados }) {
    store.dispatch('bi/loadingProfissionais', true)

    const data = {
      data: JSON.stringify(
        dados.map((item) => {
          return {
            id_profissional: item.id_profissional,
            id_plano_carreira: item.id_plano_carreira,
          }
        })
      ),
    }

    const r = await con.post(bi.profissionaisLote, data)
    store.dispatch('bi/loadingProfissionais', false)

    if (r && r.status === 200) {
      this.carregar(true)
    }

    return r || {}
  }

  async alterarFilial({ dados }) {
    const data = {
      data: JSON.stringify(
        dados.map((item) => {
          return {
            id_profissional: item.id_profissional,
            id_filial: item.id_filial,
          }
        })
      ),
    }

    const r = await con.post(bi.profissionaisLote, data)

    if (r && r.status === 200) {
      this.carregar(true)
    }

    return r || {}
  }

  async removerProfissional({ id_profissional }) {
    if (id_profissional > 0) {
      store.dispatch('bi/loadingProfissionais', true)
      const r = await con.delet(profissionais.remove + `${id_profissional}`)
      if (r && r.status === 200) {
        store.dispatch(
          'bi/removeProfissional',
          r.value[0] || r.value || { id_profissional }
        )
        this.carregar(true)
      }
      store.dispatch('bi/loadingProfissionais', false)
      return r || {}
    } else {
      return {
        status: 404,
        message: 'Profissional não encontrado',
        value: null,
      }
    }
  }
}

const apiBiProfissionais = new APIBIProfissionais()
export default apiBiProfissionais
